import { Injectable } from '@angular/core';
import { IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from '@ordersnproducts/features';
/**
 * Feature to enable or disable the modification of Arkik orders.
 * This feature is used to control whether users can modify existing Arkik orders.
 */
@Injectable()
export class ModifyArkikFeature implements IFlagFeature {
  name = Features.ENABLE_MODIFY_ARKIK;

  public isEnabled(container: IToggleContainer): boolean {
    return container[this.name].isEnabled();
  }
}
